export default __webpack_public_path__ + "static/media/Profile.0ebf20fe.svg";